import { State } from '../../reducers/rootReducer'
import { PendingRequestsReducerState } from '../../reducers/pendingRequestsReducer'

const pendingRequestsSelector = (state: State): PendingRequestsReducerState => state.pendingRequests

export default pendingRequestsSelector
